import bus from "../../../bus";
import { playerEvents } from "../../events";
import PlayableItem from "./item";

/**
 * Playable implementation
 */
export default class PlayableItemNull extends PlayableItem {
  set(props) {
    this.prevProps = this.props || {};
    this.props = props;
    this.onUpdate();
  }

  onUpdate() {
    const { status } = this.props;
    if (status !== this.prevProps.status) {
      switch (status) {
        case "playing":
          bus.emit(playerEvents.PLAY_DEFAULT_STREAM);
          break;
        default:
          break;
      }
    }
  }

  hasDuration() {
    return false;
  }
  getTitle() {
    const availableStreams = this.props ? this.props.availableStreams : null;
    let title = null;
    if (availableStreams && availableStreams.length > 0) {
      title = availableStreams[0].current_item_name;
    }
    return title || "FM Broadcast";
  }
  isLive() {
    return true;
  }
  getPlayerItemID() {
    return "playable-null";
  }
}
